import { Avatar, Chip } from '@mui/material'
import { PickingValidateSkuDetail } from '../../../../interfaces/Picking/Picking'
import { TableHeaderConfigWithType } from '../../../_EOS/Table'
import { EnumPickingValidate } from '../../pickingValidateConfig'
import React from 'react'

export const positionAlertsDetailsHeaderConfig: TableHeaderConfigWithType<PickingValidateSkuDetail>[] =
  [
    {
      field: 'urlImage',
      title: 'FOTO',
      sortable: false,
      formater: (image: unknown) => setImage(image as string)
    },
    {
      field: 'sku',
      title: 'SKU',
      formater: (_id: unknown, _row: PickingValidateSkuDetail | undefined) =>
        setSku(_id as string, _row)
    },
    { field: 'name', title: 'Nombre' },
    { field: 'realQty', title: 'Sol' },
    { field: 'pickedQty', title: 'Pick' },
    { field: 'validatedQty', title: 'Val' },
    {
      field: 'commentary',
      title: 'Obs',
      sortable: false,
      formater: (_id: unknown) => setComentary(_id)
    }
  ]

const setSku = (sku: string, entity: PickingValidateSkuDetail | undefined) => {
  return (
    <div style={{ fontSize: '0.85rem' }}>
      {sku === entity?.eaN13 ? sku.toString() : `${sku} / ${entity?.eaN13}`}
    </div>
  )
}

const setImage = (pImage: string) => {
  const image =
    pImage !== undefined
      ? pImage
      : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

  return (
    <Avatar
      style={{ height: '100px', width: '100px', textAlign: 'center' }}
      variant='square'
      alt='SkuImage'
      src={image}
    />
  )
}

const setComentary = (comentaryId: unknown) => {
  return (
    <Chip
      size='small'
      label={
        EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
          ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0].name
          : ''
      }
      variant='outlined'
      style={{
        backgroundColor:
          EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
            ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0]
                .color
            : '',
        color:
          EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
            ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0]
                .textColor
            : '',
        fontWeight: 'bold'
      }}
    />
  )
}
